import 'slick-carousel'
// import GOOGLEMAP from '../plugins/googlemap'
import GET_ARTICLES from '../plugins/getArticles'

const [w] = [window]

export default function HOME() {
  w.jQuery = $

  // map script
  // const km = w.siteinfo.mapApiKeys
  // const env_map_key = (!km[host]) ? km['local'] : km[host]
  // w.addScript({src:`https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`})

  $(() => {
  
    // トップページカスタム
    $.topInit();

    /****************************
     * movie background
     */
    $.when(
      w.load['mainvisual'],
      $.getScript('/asset/js/vendor/jquery.mb.YTPlayer.min.js')
    ).done(()=>{
      const $MV = $('[data-plugin="ytplayer"]')
      const param = id => `{
        videoURL: '${id}',
        containment: '#mainvisual',
        mute: true,
        showControls: false,
        autoPlay: true,
        useOnMobile: true,
        showYTLogo: false,
        abundance: 0,
        stopMovieOnBlur: false,
        loop: true,
        startAt: 0,
        anchor: '${($.UA.is_mobile)? 'top,center' : 'center,center'}',
        quality: '${($.UA.is_mobile)? 'default': 'hd1080'}'
      }`.replace(/\n|\s/g,'')
      $MV.attr('data-property',param('jiIBoAO64AY'))
      $MV.YTPlayer()
      $MV.YTPPlay()
    })

    // ticker
    w.load['mainvisual'].done(() => {
      GET_ARTICLES('.p-mainvisual__ticker [data-plugin="getArticles"]',{
        makeItem(item,opt){
          return $(`<div class="p-mainvisual__ticker-item__inner">
          <p class="date">${item.date}</p>
          <a href="${item.href}" class="p-mainvisual__ticker-article">
            ${item.title}<span class="category">［${item.category.name}］</span>
          </a>
        </div>`)[0]
        }
      })
    })
  
    w.load['block-works'].done(() => {
      GET_ARTICLES('.p-block-works [data-plugin="getArticles"]').done(() => {
        $('.p-block-works__list').slick({
          autoplay: true,
          fade: false,
          speed: 200,
          pauseOnHover: false,
          pauseOnFocus: false,
          centerMode: true,
          arrows: false,
          infinite: true,
          variableWidth: true,
          swipeToSlide:true,
          slidesToShow: 4,
          initialSlide: 0,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          }]
        })
      })
    })

    w.load['block-news'].done(()=> {
      GET_ARTICLES('.p-block-news [data-plugin="getArticles"]',{
        makeItem(item,opt){
          const body_len = ($.UA.is_mobile)? 40:119
          return $(`
            <a href="${item.href}" class="p-block-news__item">
              <figure class="thumb">
                <div class="thumb-img" style="background-image:url(${item.thumb})"><img src="${item.thumb}" width="180" alt="${item.title}"></div>
              </figure>
              <div class="body">
                <span class="date">${item.date}</span>
                <h5 class="title">${item.title}</h5>
                <p class="desc">${$.strip_tags(item.body).str_truncate(body_len)}</p>
              </div>
            </a>`)[0]
        }
      })
    })

    // console.log('block-news読み込みより後に書く')
  
    // ブロック整形
    // ;(function(__){ $.each(__, $.topBlockCustomizer) }({
    //   'news':{
    //     button:{
    //       disp: true,
    //       text: 'VIEW ALL',
    //       attr: {
    //         class: 'button button-inverse c-btn-icon-right'
    //       }
    //     },
    //     title:{
    //       html: '<span>NEWS</span><small>新着情報</small>' // プレーンテキストで動的にする場合は false
    //     },
    //     itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
    //       $this
    //         .append( $title.append($new) )
    //         .append( $catetitle )
    //         .append( $date )
    //         .append( $catch )
    //         .append( $body );
    //       // $date.insertAfter( $catetitle );
    //     }
    //   },
    //   'works':{
    //     title:{
    //       html: '<span>WORKS</span><small>加工事例</small>' // プレーンテキストで動的にする場合は false
    //     },
    //     itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
    //       $this
    //         .append( $title.append($new) )
    //         .append( $catetitle )
    //         .append( $date )
    //         .append( $catch )
    //         .append( $body );
    //       // $date.insertAfter( $catetitle );
    //     }
    //   },
    // }));
  
  });


  // map
  // document.addEventListener( 'DOMContentLoaded', () => {
  //   $.when(
  //     w.load['mapScript'],
  //     w.load['contentFooter']
  //   ).done( () => GOOGLEMAP() )
  // } )
}